import { CreateTopupRequestDto } from '@portal/models/module';
import { v4 } from 'uuid';
import { getInstance } from './securitySdkConfig';

const BASE_URL = '/device';
const BASE_URL_V2 = '/mobile-recharge';

export interface RegisterInformationResponse {
  lastNumbers: string;
}

const DeviceApi = {
  getRegisterInformation: async (): Promise<RegisterInformationResponse> => {
    const instance = getInstance();
    const { data } = await instance.get<RegisterInformationResponse>(
      '/device/register-information'
    );
    return data;
  },

  getMyDevices: async () => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL}/`);
    return data;
  },

  getUserDevices: async (userId: string) => {
    const instance = getInstance();
    const { data } = await instance.get(`/v3${BASE_URL}/user/${userId}`);
    return data;
  },

  getMyBlockedDevices: async () => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL}/blocked-devices`);
    return data;
  },

  deleteDevice: async (deviceId: string) => {
    const instance = getInstance();
    const { data } = await instance.delete(`${BASE_URL}/${deviceId}`);

    return data;
  },

  unlockDevice: async (deviceId: string) => {
    const instance = getInstance();
    const { data } = await instance.delete(`${BASE_URL}/unlock/${deviceId}`);

    return data;
  },

  blockDevice: async (deviceId: string) => {
    const instance = getInstance();
    const { data } = await instance.put(`${BASE_URL}/${deviceId}`);

    return data;
  },

  getDeviceCount: async () => {
    const instance = getInstance();
    const { data } = await instance.get(`/v3${BASE_URL}/count`);
    return data;
  },

  getCarriers: async (areaCode: string) => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL_V2}/${areaCode}/carriers`);

    return data;
  },

  getCarrierProductList: async (areaCode: string, carrierId: string) => {
    const instance = getInstance();
    const { data } = await instance.get(
      `${BASE_URL_V2}/${areaCode}/carrier/${carrierId}`
    );

    const products = Array.isArray(data?.value) ? data.value : [];

    return products.map(
      (item: {
        productName: string;
        maxValue: number;
        minValue: number;
      }): models.CarrierProduct => ({
        name: item.productName,
        amount: item.maxValue,
      })
    );
  },

  getRechargeHistory: async (): Promise<models.RechargeHistoryItem[]> => {
    const instance = getInstance();
    const { data } = await instance.get<models.RechargeHistoryItem[]>(
      `${BASE_URL_V2}/history`
    );

    return data;
  },

  rechargeTransaction: async (body: CreateTopupRequestDto, pin: string) => {
    const instance = getInstance();
    const { data } = await instance.post(
      `${BASE_URL_V2}`,
      {
        ...body,
        authenticate: {
          pin,
        },
      },
      { headers: { 'X-Idempotency-Key': v4() } }
    );

    return data;
  },

  getRecharges: async (params: advancedFilterModels.RechargeMobileFilter) => {
    const instance = getInstance();
    const { data } = await instance.get(`${BASE_URL_V2}`, {
      params,
    });
    return data;
  },
};

export default DeviceApi;
